"use client"

import { Button } from "@/components/ui/button"
import type { BriefParticipationState } from "@/types"

interface CollabFooterCtaProps {
  participationState: BriefParticipationState
}

// The four-branch footer logic (`if remaining===0 / hasSuggested /
// remaining<=3 / else`) lives in `Brief::ParticipationState` on the
// server. The component is two lines of JSX: read message,
// optionally render the button (carve-up critique #2).
export function CollabFooterCta({ participationState }: CollabFooterCtaProps) {
  const { message, button_label, button_href } = participationState

  return (
    <div className="bg-brand-section flex flex-col items-center gap-3 rounded-xl p-8 text-center">
      <p className="text-md text-primary_on-brand font-semibold">{message}</p>
      {button_label && button_href && (
        <Button color="secondary" href={button_href} size="md">
          {button_label}
        </Button>
      )}
    </div>
  )
}
